import React, { useState } from 'react'
import { useShowError } from '@aserto/console-common'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { reactQueryDefaultOptions } from '../../types/local/general'

const CustomQueryClientProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const showError = useShowError()
  const [queryClient] = useState<QueryClient>(
    new QueryClient({
      defaultOptions: {
        queries: {
          ...reactQueryDefaultOptions,
          onError: undefined,
        },
      },
      queryCache: new QueryCache({
        onError: (error, query) => {
          if (query.meta?.showError === false) {
            return
          }

          showError(error)
        },
      }),
    })
  )

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}

export default CustomQueryClientProvider
